import {MenuItemOrder} from "../../../../@domain/menu-order";
import {createReducer, on} from "@ngrx/store";
import * as actions from "../menu-order/menu-order.action";

export interface State {
  menuItemOrder: MenuItemOrder[]
}

export const initialState: State = {
  menuItemOrder: []
}

export const menuOrderReducer = createReducer(
  initialState,
  on(actions.SET_MENU_ITEM_ORDER, (state, { payload }) => {
    return {
      ...state,
      // menuItemOrder: state.menuItemOrder === payload ? state.menuItemOrder : payload
      menuItemOrder: payload
    };
  }),
);
